import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Download = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.707 17.7069L16.707 20.7069C16.316 21.0979 15.684 21.0979 15.293 20.7069L12.293 17.7069C12.098 17.5119 12 17.2559 12 16.9999C12 16.7439 12.098 16.4878 12.293 16.2928C12.684 15.9018 13.316 15.9018 13.707 16.2928L15 17.5859L15 5.99988C15 5.44788 15.448 4.99988 16 4.99988C16.552 4.99988 17 5.44788 17 5.99988L17 17.5859L18.293 16.2928C18.684 15.9018 19.316 15.9018 19.707 16.2928C20.098 16.6838 20.098 17.3159 19.707 17.7069ZM5 19V25C5 26.104 5.896 27 7 27H25C26.105 27 27 26.104 27 25V19C27 18.4477 26.5523 18 26 18C25.4477 18 25 18.4477 25 19V25H7V19C7 18.4477 6.55228 18 6 18C5.44772 18 5 18.4477 5 19Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Download
